/**
 * Comprueba si el cliente puede hablar con Firestore.
 * Sin usuario: una lectura debe devolver permission-denied (reglas) = conexión OK.
 * unavailable = no llega al servidor (red, API key, Firestore no creado, etc.).
 */
import { doc, getDoc } from 'firebase/firestore';

export async function runFirestoreConnectivityTest(db) {
  const t0 = performance.now();
  try {
    await getDoc(doc(db, 'usuarios', '__probe_conexion__'));
    return {
      ok: true,
      ms: Math.round(performance.now() - t0),
      interpretacion:
        'Lectura completada (raro sin auth; revisá reglas si algo falla después).',
    };
  } catch (e) {
    const ms = Math.round(performance.now() - t0);
    const code = e?.code || '';
    if (code === 'permission-denied') {
      return {
        ok: true,
        ms,
        interpretacion:
          'Firestore responde bien: el servidor rechazó la lectura sin login (esperado con tus reglas). La conexión funciona.',
      };
    }
    return {
      ok: false,
      ms,
      code,
      message: e?.message || String(e),
      interpretacion:
        code === 'unavailable'
          ? 'No hay conexión con los servidores de Firestore. Revisá internet, API key en Google Cloud, que exista la base Firestore en la consola y que no bloquee el firewall.'
          : 'Revisá el código y el mensaje; puede ser reglas o proyecto mal configurado.',
    };
  }
}

export function summarizePublicConfig() {
  const pid = import.meta.env.VITE_FIREBASE_PROJECT_ID || '(vacío)';
  const domain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '(vacío)';
  const key = import.meta.env.VITE_FIREBASE_API_KEY || '';
  const keyHint = key ? `${key.slice(0, 8)}…${key.slice(-4)}` : '(vacío)';
  return { projectId: pid, authDomain: domain, apiKeyHint: keyHint };
}
